import { Layout, Button, Card, Form, Input, Image, Typography } from "antd";
import CustomFunctions from "../dependencies/custom/custom-functions";
import logo2 from "../../img/brand/brand.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import utils from "../dependencies/custom/react-utilities";
import Settings from "../dependencies/custom/settings";
import Utilities from "../dependencies/custom/react-utilities";
import useWindowDimensions from "../hooks/screensize";
const { Title } = Typography;

const { Footer, Content } = Layout;

export default function SignUp() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { vpWidth, vpHeight } = useWindowDimensions();
  const isMobile = vpWidth <= 768;

  useEffect(() => {
    form.setFieldsValue({ countryCode: "+256" });
    // console.log(Settings);
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    const { password, cpassword } = values;
    if (password != cpassword) {
      Utilities.showNotification(undefined, "Password mismatch");
      return;
    }
    delete values["cpassword"];
    const res = await utils.fetchWithAuth(
      "POST",
      Settings.urls.auth.signup,
      values,
      navigate,
    );
    if (res.ok) {
      Utilities.showNotification(
        undefined,
        "User created successfully",
        "text-success",
      );
      navigate("../../otp", { state: { user: res?.data } });
      // navigate('/');
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
    setLoading(false);
  };

  // const onFinishFailed = (errorInfo) => {
  //   console.log("Failed:", errorInfo);
  // };

  return (
    <>
      <Layout className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div
            className="sign-up-header mt-5x"
            style={{
              // backgroundImage: `url(${banner})`,
              background: isMobile
                ? "transparent"
                : "linear-gradient(to right, #1f1f5d, #8e44ad)",
              height: "300px",
              border: isMobile && "none",
              boxShadow: isMobile && "none",
            }}
          />

          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            title={
              <div>
                <div className="d-flex justify-content-center mt-3">
                  <Image
                    className="mb-2"
                    preview={false}
                    width={Settings?.logoWidth}
                    src={logo2}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center mb-5x text-center">
                  <Title
                    level={5}
                    className="text-wrap fw-bold"
                    style={{ maxWidth: "90%" }}
                  >
                    Hillside Schools – Naalya
                  </Title>
                </div>
              </div>
            }
            style={{ backgroundColor: "#fafafa" /*marginTop: '-190px'*/ }}
          >
            <Form
              name="basic"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              className="row-col"
              form={form}
            >
              <Form.Item
                name="phone"
                rules={[
                  { required: true, message: "Please input your telephone!" },
                ]}
              >
                <Input
                  addonBefore={CustomFunctions.prefixSelector("countryCode")}
                  style={{ width: "100%" }}
                  placeholder="Telephone"
                />
              </Form.Item>
              <Form.Item
                name="fullName"
                rules={[
                  { required: true, message: "Please enter your full name!" },
                ]}
              >
                <Input placeholder="Full name" />
              </Form.Item>
              <Form.Item
                name="email"
                rules={[
                  { required: true, type: "email", message: "Invalid email!" },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item
                name="cpassword"
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                ]}
              >
                <Input.Password placeholder="Confirm Password" />
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  SIGN UP
                </Button>
              </Form.Item>
            </Form>
            <p className="font-semibold text-muted text-center">
              Already have an account?{" "}
              <Link to="/signin" className="font-bold text-dark">
                Sign In
              </Link>
            </p>
          </Card>
        </Content>
        {/* <Footer>
          <p className="copyright">
            {" "}
            Copyright © 2025 S4D EduNexus.{" "}
          </p>
        </Footer> */}
      </Layout>
    </>
  );
}
